module.exports = __webpack_public_path__ + "static/valora-5abc480e8dfe710b85258eaebf2fb283.png";